import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

import styled from "styled-components";

const RowContainer = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;
const ColumnContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 10px;
`;
const LeftColumnContainer = styled(ColumnContainer)`
  flex-grow: 0;
`;
const RightColumnContainer = styled(ColumnContainer)`
  flex-grow: 1;
`;

const SkeletonBox = styled(FixaSkeleton)`
  width: 48px !important;
  height: 48px;
`;
const SkeletonRow = styled(FixaSkeleton)`
  width: 100%;
  height: 12px;
  margin: 2px !important;
`;
export function MediasViewSearchListItemSkeleton() {
  return (
    <RowContainer>
      <LeftColumnContainer>
        <SkeletonBox />
      </LeftColumnContainer>
      <RightColumnContainer>
        <SkeletonRow />
        <SkeletonRow />
        <SkeletonRow />
      </RightColumnContainer>
    </RowContainer>
  );
}
